import ConnectWalletButton from 'components/ConnectWalletButton'
import { useAirdropContract } from 'hooks/useContract'
import { useSingleCallResult } from 'state/multicall/hooks'
import { useTransactionAdder } from 'state/transactions/hooks'
import { MainApiRoute, callMainApi, convertParamsToString, useMainApi } from 'hooks/useMainApi'
import { Button, Container, useMatchBreakpoints, useToast } from '@echodex/uikit'
import useAccountActiveChain from 'hooks/useAccountActiveChain'
import { CHAIN_IDS } from 'utils/wagmi'
import { useCalculateYourPoints } from 'views/Airdrop/hooks'
import { useTranslation } from '@echodex/localization'
import { transactionErrorToUserReadableMessage } from 'utils/transactionErrorToUserReadableMessage'
import { isUserRejected } from 'utils/sentry'
import CardAirdrop from 'views/Airdrop/CardAirdrop'
import PointHistoryTable from 'views/Airdrop/PointHistoryTable'
import Image from 'next/image'
import Link from 'next/link'
import { Icon } from '@iconify/react'
import LeaderBoardTable from 'views/Airdrop/LeaderBoardTable'
import { useState } from 'react'
import styled from 'styled-components'

const StyledBox = styled(Link)`
    cursor: pointer;
    img {
        border-radius: 20px;
        box-shadow: 0px 0px 12px 0px rgba(99, 216, 160, 0.7);
        :hover {
            box-shadow: 0px 0px 18px 5px rgba(44, 126, 85, 0.7);
        }
    }
`
const AirDrop = () => {
    const { account, chainId } = useAccountActiveChain()

    const airdropContract = useAirdropContract()
    const [dayId] = useState(parseInt(`${new Date().getTime() / 1000 / (24 * 60 * 60)}`))
    const toast = useToast()
    const checkedInCall = useSingleCallResult({
        contract: account ? airdropContract : null,
        functionName: 'checkedIn',
        args: account ? [account, dayId] : null,
    })

    const { t } = useTranslation()

    const addTransaction = useTransactionAdder()
    const [totalLiquidityValue, totalFarmingValue, totalSwapValue] = useCalculateYourPoints()

    const airdropUserInfo = useMainApi(MainApiRoute.GET_AIRDROP_USER_INFO, { address: account })

    const checkIn = async () => {
        if (!airdropContract) {
            throw new Error('No airdrop contract')
        }

        if (!account || !chainId) return
        airdropContract.estimateGas
            .checkIn({ account })
            .then(() => {
                airdropContract.write
                    .checkIn()
                    .then(async (response) => {
                        await callMainApi(chainId, MainApiRoute.CHECK_IN, convertParamsToString({ address: account }))
                        addTransaction(
                            { hash: response },
                            {
                                summary: `Attend airdrop today`,
                            },
                        )
                    })
                    .catch(() => {
                        // don't show error if user rejected
                    })
            })
            .catch((error) => {
                if (!isUserRejected(error)) {
                    toast.toastError(transactionErrorToUserReadableMessage(error, t))
                }
            })
    }
    const { isMobile } = useMatchBreakpoints()
    return (
        <Container>
            <div className="mt-[20px] lg:mt-[64px] mb-[64px]">
                <div className="flex flex-col gap-6">
                    <div className="gap-6 fa-center max-lg:flex-col">
                        <div className="relative sm:py-[38px] py-6 px-6 rounded-xl lg:h-[357px]  lg:w-[794px] w-full md:first-letter:h-[335px] overflow-hidden bg-gray">
                            <Image
                                className="absolute top-[0px] left-[0px] h-full overflow-hidden opacity-[0.1]"
                                alt="texture"
                                src="/images/texture.png"
                                width={700}
                                height={335}
                            />
                            <Image
                                className="absolute top-[0px] left-[10%] md:left-[40%] w-[444.93px] h-[335px]"
                                alt="des"
                                src="/images/des.png"
                                width={445}
                                height={335}
                            />
                            <div className="relative z-[20]">
                                <div className="flex justify-between max-sm:flex-col max-sm:gap-2">
                                    <div className="flex flex-col">
                                        <div className="text-xl leading-[30px] font-medium text-text1">Your Point</div>
                                        <div className="text-pri text-[40px] font-semibold">
                                            {Number(airdropUserInfo?.point)
                                                ? Number(airdropUserInfo?.point).toFixed(4)
                                                : 0}
                                        </div>
                                    </div>
                                    <Link
                                        href="/airdrop/how-to-get-points"
                                        className=" leading-[21px] font-medium text-pri flex cursor-pointer group gap-1"
                                    >
                                        <div className="group-hover:underline">Get more points</div>
                                        <div>
                                            <Icon icon="ic:round-arrow-back" className="text-[20px] rotate-180" />
                                        </div>
                                    </Link>
                                </div>
                                <ListCard
                                    totalLiquidityValue={totalLiquidityValue}
                                    totalFarmingValue={totalFarmingValue}
                                    totalSwapValue={totalSwapValue}
                                />
                            </div>
                        </div>
                        <div className="relative py-6 px-8 h-[357px] flex flex-col items-center rounded-xl  lg:w-[465px] w-full  overflow-hidden bg-gray">
                            <Image
                                alt="texture"
                                src="/images/texture.png"
                                width={700}
                                height={300}
                                className="absolute top-[0px] left-[0px] h-full object-cover overflow-hidden opacity-[0.08]"
                            />
                            <div className="w-full mb-4 text-[20px] leading-[30px] font-medium text-left relative ">
                                Check attendance
                            </div>
                            <div className="relative flex flex-col items-start justify-start gap-[42px] text-17xl text-primary w-full">
                                <div className="flex-center w-full relative   rounded-[19px] [background:linear-gradient(57.9deg,_rgba(143,_255,_225,_0.3),_rgba(143,_255,_225,_0.05))] box-border  h-[138px] overflow-hidden shrink-0 border-[0.5px] border-solid border-text-2">
                                    <div className="absolute w-full h-full">
                                        <Image src="/images/polygon.png" alt="polygon" width={700} height={300} />
                                    </div>
                                    <div className=" text-[36px] text-pri text-center capitalize font-semibold [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0.25)]">
                                        +100 Points
                                    </div>
                                </div>

                                {account ? (
                                    <Button
                                        onClick={checkIn}
                                        disabled={Boolean(checkedInCall.result)}
                                        isLoading={checkedInCall.loading}
                                        className="leading-[21px] font-medium w-full"
                                    >
                                        {checkedInCall.result ? 'Attended today. Please come back tomorrow' : 'Attend'}
                                    </Button>
                                ) : (
                                    <div className="w-full">
                                        <ConnectWalletButton className="w-full" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <StyledBox href="/add" className="relative w-full min-h-[50px] md:min-h-[100px] mb-3">
                        <div className="absolute w-full">
                            <Image
                                src="/images/banner-airdrop.png"
                                alt="banner"
                                width={1000}
                                height={300}
                                className="md:w-full "
                            />
                        </div>
                        {!isMobile && (
                            <Link
                                href="/add"
                                className="flex justify-end w-full md:pr-[20px] lg:pr-[50px] xl:pr-[80px] items-center min-h-[80px] lg:min-h-[100px] "
                            >
                                <Button
                                    style={{ opacity: 1, boxShadow: '0px 3px 3px 3px rgba(0,0,0,.4)' }}
                                    className="!hover:opacity-1 hover:scale-110"
                                >
                                    Add Liqudity Ver3 now
                                </Button>
                            </Link>
                        )}
                    </StyledBox>
                    {isMobile && (
                        <Button
                            style={{ opacity: 1, boxShadow: '0px 3px 3px 3px rgba(0,0,0,.4)' }}
                            className="!hover:opacity-1 hover:scale-110"
                        >
                            Add Liquidity V3 now
                        </Button>
                    )}
                    <div className="flex gap-6 max-lg:flex-col">
                        <div className="rounded-xl lg:w-[794px] overflow-hidden min-h-[300px] h-[588px] bg-gray">
                            <div className="gap-2 px-4 py-6 font-semibold fa-center">
                                <Icon
                                    icon="material-symbols:credit-score-outline-rounded"
                                    className="text-pri text-[24px]"
                                />
                                Point History
                            </div>
                            {account ? (
                                <PointHistoryTable histories={airdropUserInfo && airdropUserInfo.histories} />
                            ) : (
                                <div className=" text-[24px] font-semibold flex-center mt-6 text-pri">
                                    Please connect your wallet
                                </div>
                            )}
                        </div>
                        <div className="rounded-xl lg:w-[465px] min-h-[300px] overflow-hidden  h-[588px] bg-gray">
                            <div className="gap-2 px-4 py-6 font-semibold fa-center">
                                <Icon icon="icon-park-outline:ranking-list" className="text-pri text-[24px]" />
                                Leader Board
                            </div>
                            <LeaderBoardTable />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

interface ListCard {
    totalLiquidityValue: number
    totalSwapValue: number
    totalFarmingValue: number
}
const ListCard = (props: ListCard) => {
    return (
        <div className="grid grid-cols-3 gap-4 mt-4 max-md:grid-cols-1">
            <CardAirdrop
                totalAmount={props.totalLiquidityValue}
                description="Point per day by liquidity"
                nameButton="Add Liquidity V3"
                link="/add"
            />
            <CardAirdrop
                totalAmount={props.totalFarmingValue}
                description="Point per day by staking"
                nameButton="Farm Now"
                link="/farming"
                icon="ic:round-swap-horiz"
            />
            <CardAirdrop
                totalAmount={props.totalSwapValue}
                description="Point per day by volume"
                nameButton="Swap Now"
                link="/swap"
                icon="ph:coins-thin"
            />
        </div>
    )
}

AirDrop.chains = CHAIN_IDS
export default AirDrop
